import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M67.8 48H75.8L47.8 8L20 48H27.8L12.2 72H39.88V88H55.72V72H83.8L67.8 48Z",
  fill: "inherit"
}), 'Christmas', {
  viewBox: '0 0 96 96'
});